class ArrayUtil {
    static contains(target: string[], value: string | number, strict: boolean = false): boolean {
        const _value: string =  String(value); 
        const regex = new RegExp(`${strict ? "^" : ""}${_value}${strict ? "$" : ""}`, "gi")
        if (!target) {
            return false;
        }
        for (const item of target) {
            if (String(item).match(regex)?.length) {
                return true;
            }
        }


        return false;
    }

    static addItem<T = any>(list: any[], item: any): T[] {
        const _list: T[] = list;
        _list.push(item)
        return _list;
    }

    static removeItem<T = any>(list: any[], item: any): T[] {
        if (!list) {
            return list;
        }
        const _list: T[] = list?.filter((i) => i !== item) || list;
        return _list;
    }
}

export { ArrayUtil }